import {
  FETCH_DEVICES,
  FETCH_DEVICES_SUCCESS,
  FETCH_DEVICES_FAILURE,
} from '../actions/devices';

const INITIAL_STATE = { loading: true, services: {} };

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_DEVICES:
      return {
        ...state,
        loading: true,
        requested: true,
      };
    case FETCH_DEVICES_SUCCESS:
      return {
        ...state,
        services: action.payload,
        requested: true,
        loading: false,
        error: null,
        cacheValid: true,
      };
    case FETCH_DEVICES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default: return state;
  }
}
